module.exports = __webpack_public_path__ + "static/media/details-1.33ab9f1e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/details-1.jpeg
// module id = 69
// module chunks = 0